import { render, staticRenderFns } from "./LoginP.vue?vue&type=template&id=925f9a98&scoped=true&"
import script from "./LoginP.vue?vue&type=script&lang=js&"
export * from "./LoginP.vue?vue&type=script&lang=js&"
import style0 from "./LoginP.vue?vue&type=style&index=0&id=925f9a98&scoped=true&lang=css&"
import style1 from "./LoginP.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925f9a98",
  null
  
)

export default component.exports